import apiClientCreator from "../../../../helpers/api/request";
import { mapState, mapGetters } from "vuex";

/* eslint-disable */
export default {
  name: "BrickBreakerGame",
  computed: {
    ...mapState("user", ["auth"]),
  },
  mounted: function() {
    var c = document.getElementById("canvas");
    var context = c.getContext("2d");
    $(document).ready(function() {
      startGame();
    });
    // JavaScript Document
    var blinkCount = 0;
    var blinking;
    var blinkLetters;
    var scene;
    var i;
    var j;
    var token;
    var tokenSpeed;
    var paddlePrevousToken;
    var scenes = ["s2", "s3", "s4", "s5", "s6", "s7"];
    var endGameData = {
      score: score,
      game: "Brick-breaker"
    };

    function blink() {
      if (!(blinkCount % 6)) {
        $("#B").css("color", "#e6bb45");
        $("#S").css("color", "#FFF");
      } else {
        $("#B").css("color", "#000");
        $("#S").css("color", "red");
      }

      if (!(blinkCount % 5)) {
        $("#W").css("color", "#e6bb45");
        $("#F").css("color", "#FFF");
      } else {
        $("#W").css("color", "#000");
        $("#F").css("color", "red");
      }

      if (!(blinkCount % 7)) {
        $("#three").css("color", "#0CC");
      } else {
        $("#three").css("color", "#000");
      }
      blinkCount++;
    }

    function clickToStart() {
      $("#ctg").animate({ left: 352 }, 300, function() {
        $("#ctg").animate({ left: 355 }, 500, clickToStart());
      });
    }

    function startGame() {
      // document.getElementById("introSound").muted = true;
      for (scene in scenes) {
        window.clearTimeout(scenes[scene]);
      }
      $(".intro").hide(200);
      $("#canvas, .sidebar").show();
      blinking ? clearInterval(blinkLetters) : blinking;
      initial();
    }

    // JavaScript Document
    var gameOver;
    //canvas
    var context;
    var WIDTH = 990;
    var HEIGHT = 600;

    //balls
    var balls;
    var ball;
    var threeBallsAtWork;
    var fastDuration;
    var fast;
    var ballsCount;
    var score;

    //ball + direction and speed

    var radius = 12;

    //paddle

    var paddlex = 650;
    var paddleh = 20;
    var paddlew = 200;

    var paddleColor;
    var paddleTouch;
    var paddleTouchDuration;
    var paddleWidenDuration;
    var paddleShrinkDuration;
    var paddleLastToken;
    var paddlePreviousToken;

    //bricks
    var bricks;
    var n_brick_cols = 13;
    var n_brick_rows = 6;
    var brick_padding = 5;
    var brick_width =
      (WIDTH - brick_padding * (n_brick_cols + 1)) / n_brick_cols;
    var brick_height = 30;

    var pickBrickColor = [
      "#b29b59",
      "#ccab52",
      "#e6bb45",
      "#ffc933",
      "#ffd666",
      "#ffdd7f",
      "#ffe499"
    ];

    bricks = new Array(n_brick_rows);
    for (i = 0; i < n_brick_rows; i++) {
      bricks[i] = new Array(n_brick_cols);
      for (j = 0; j < n_brick_cols; j++) {
        bricks[i][j] = 1;
      }
    }

    //keyboard
    var paddleRight = false;
    var paddleLeft = false;

    var rightDown = false;
    var leftDown = false;

    //pause/gameover
    var pause;
    var prepause;
    var lostCount;

    //mouse
    var canvasMinX;
    var canvasMaxX;
    var canvasStart;

    //Tokens
    var tokenLetters = new Object();

    function start_over() {
      clearInterval(frames);
      for (ball in balls) {
        delete balls[ball];
      }
      for (token in tokenLetters) {
        delete tokenLetters[token];
      }
      for (i = 0; i < n_brick_rows; i++) {
        bricks[i] = new Array(n_brick_cols);
        for (j = 0; j < n_brick_cols; j++) {
          bricks[i][j] = 1;
        }
      }

      balls = { 0: { x: 100, y: 300, dx: 12, dy: 6 } };
      ballsCount = 0;

      $("#canvas").css("background-image", "none");
      fastDuration = 0;
      paddleTouch = false;
      paddleTouchDuration = 0;
      paddleShrinkDuration = 0;
      paddleWidenDuration = 0;
      paddleColor = "#e6bb45";

      fast = false;
      threeBallsAtWork = false;

      gameOver = false;
      score = 0;
      pause = false;
      prepause = true;
      lostCount = 0;
      startAnimate();
      $("#score").html(score);
      $("#announce").hide();
      context.clearRect(0, 0, WIDTH, HEIGHT);
      window.setTimeout(function() {
        frames = setInterval(draw, 20);
        prepause = false;
        $("#canvas").css("background-image", "url(images/foxes.png)");
      }, 1200);
    }

    function initial() {
      balls = { 0: { x: 100, y: 300, dx: 12, dy: 6 } };
      ballsCount = 0;

      fastDuration = 0;
      paddleTouch = false;
      paddleTouchDuration = 0;
      paddleShrinkDuration = 0;
      paddleWidenDuration = 0;
      paddleColor = "#e6bb45";

      fast = false;
      threeBallsAtWork = false;

      gameOver = false;
      score = 0;
      pause = false;
      lostCount = 0;
      prepause = true;

      $(document).keydown(keyDown);
      $(document).keyup(keyUp);
      $(document).mousemove(onMouseMove);
      $("#canvas").click(initPause);
      $("#announce").click(initPause);
      // $("#togglesound").click(toggleSound);
      $(".start_over").click(start_over);
      var context = canvas.getContext("2d");
      startAnimate();
      var canvasStart = $("#canvas").offset().left;
      window.setTimeout(function() {
        frames = setInterval(draw, 20);
        prepause = false;
        $("#canvas").css("background-image", "url(images/foxes.png)");
      }, 1200);
    }

    function draw() {
      clear();
      drawBalls();
      paddle();
      drawBricks();
      bounce();
      Tokens();

      for (ball in balls) {
      }
    }

    function rect(c, x, y, w, h) {
      context.fillStyle = c;
      context.beginPath();
      context.rect(x, y, w, h);
      context.closePath();
      context.fill();
    }

    function drawBalls() {
      if (fastDuration) {
        fastDuration--;
      } else if (fast) {
        balls[ball].dx *= 2 / 3;
        balls[ball].dy *= 2 / 3;
        fast = false;
      }

      for (ball in balls) {
        var dx = balls[ball].dx;
        var dy = balls[ball].dy;

        balls[ball].x += dx;
        balls[ball].y += dy;

        var y = balls[ball].y;
        var x = balls[ball].x;

        context.fillStyle = "#555";
        context.beginPath();
        context.arc(x, y, radius, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
      }

      if (Object.keys(balls).length == 1) threeBallsAtWork = false;
    }

    function clear() {
      context.clearRect(0, 0, WIDTH, HEIGHT);
    }

    function paddle() {
      if (rightDown && paddlex + paddlew < WIDTH) {
        paddlex += 15;
      }
      if (leftDown && paddlex > 0) {
        paddlex -= 15;
      }

      if (paddleWidenDuration || paddleShrinkDuration) {
        if (paddlew == 200) {
          if (paddleLastToken === "W") paddlew = 300;
          else paddlew = 100;
        }
        if (paddlew == 100) {
          if (!paddleShrinkDuration || paddleLastToken === "W") paddlew = 200;
        }
        if (paddlew == 300) {
          if (paddleLastToken === "S") paddlew = 200;
        }
      } else paddlew = 200;

      paddleWidenDuration && paddleWidenDuration--;
      paddleShrinkDuration && paddleShrinkDuration--;

      rect(paddleColor, paddlex, HEIGHT - paddleh, paddlew, paddleh);

      if (paddleTouch && paddleTouchDuration == 20) {
        paddleColor = "#e6bb45";
        paddleTouch = false;
        paddleTouchDuration = 0;
      }
      if (paddleTouch && paddleTouchDuration < 20) {
        paddleTouchDuration++;
      }
    }

    function drawBricks() {
      var isWon = true;
      for (i = 0; i < n_brick_rows; i++) {
        for (j = 0; j < n_brick_cols; j++) {
          if (bricks[i][j] == 1) {
            var color = pickBrickColor[i];
            isWon = false;
            rect(
              color,
              brick_padding + j * (brick_width + brick_padding),
              brick_padding + i * (brick_height + brick_padding),
              brick_width,
              brick_height
            );
          }
        }
      }

      if (isWon == true) {
        clearInterval(frames);
        $("#announce").append(" you won!");
        $("#announce").show();
        for (ball in balls) {
          delete balls[ball];
          gameOver = true;
        }
      }
    }

    function Tokens() {
      for (token in tokenLetters) {
        var changedTokenColor;
        tokenSpeed = 10;
        //hit bottom
        if (tokenLetters[token].y > HEIGHT) {
          delete tokenLetters[token];
          break;
        }
        //collect
        if (
          tokenLetters[token].y + tokenSpeed > HEIGHT - paddleh &&
          tokenLetters[token].x - 5 > paddlex &&
          tokenLetters[token].x + 5 < paddlex + paddlew
        ) {
          switch (tokenLetters[token].type) {
            case "B":
              score += 100;
              $("#score").html(score);
              delete tokenLetters[token];
              break;
            case "W":
              score += 20;
              $("#score").html(score);
              if (!paddleWidenDuration) paddlex -= 50;
              paddleWidenDuration += 150;
              paddlePrevousToken = paddleLastToken;
              paddleLastToken = "W";
              delete tokenLetters[token];
              break;
            case "3":
              score += 30;
              $("#score").html(score);
              threeBalls();
              delete tokenLetters[token];
              break;
            case "F":
              score -= 100;
              $("#score").html(score);
              if (!fastDuration) {
                for (ball in balls) {
                  balls[ball].dx *= 1.5;
                  balls[ball].dy *= 1.5;
                }
                fast = true;
              }
              fastDuration += 20;
              delete tokenLetters[token];
              break;
            case "S":
              score -= 100;
              $("#score").html(score);
              if (!paddleShrinkDuration) paddlex += 50;
              paddleShrinkDuration += 150;
              paddlePrevousToken = paddleLastToken;
              paddleLastToken = "S";
              delete tokenLetters[token];
              break;
          }
        }

        if (tokenLetters[token]) {
          var tokenColor;
          var changedTokenColor;

          var tokenX = tokenLetters[token].x;
          var tokenY = (tokenLetters[token].y += tokenSpeed);
          var type = tokenLetters[token].type;
          ++tokenLetters[token].color;
          switch (tokenLetters[token].type) {
            case "B":
              tokenColor = "#000";
              changedTokenColor = "#e6bb45";
              break;
            case "W":
              tokenColor = "#000";
              changedTokenColor = "#050";
              break;
            case "3":
              tokenColor = "#000";
              changedTokenColor = "#0CC";
              break;
            case "F":
              tokenColor = "#bd0a01";
              changedTokenColor = "#000";
              break;
            case "S":
              tokenColor = "#bd0a01";
              changedTokenColor = "#ffffff";
              break;
          }

          tokenLetters[token].color % 7 !== 0
            ? tokenColor
            : (tokenColor = changedTokenColor);

          context.fillStyle = tokenColor;
          context.font = "45px Arial Black, Gadget, sans-serif";
          context.fillText(type, tokenX, tokenY);
        }
      }

      function threeBalls() {
        if (!threeBallsAtWork) {
          for (ball in balls) {
            var y = balls[ball].y;
            var x = balls[ball].x;
            var dx = balls[ball].dx;
            var dy = balls[ball].dy;

            balls[++ballsCount] = { x: x, y: y, dx: -dx, dy: dy };
            balls[++ballsCount] = { x: x, y: y, dx: dx, dy: -dy };
            threeBallsAtWork = true;
          }
        }
      }
    }

    function bounce() {
      //bricks

      function brickHit(i, j, y, x) {
        bricks[i][j] = 0;

        score += 12;
        $("#score").html(score);
        var random = Math.random();
        if (random < 0.7) {
          tokenLetters["pos-i" + i + "j" + j] = new Object();
          var newToken = tokenLetters["pos-i" + i + "j" + j];
          newToken["y"] = y;
          newToken["x"] = x;
          newToken["color"] = 0;

          random = Math.random();
          if (threeBallsAtWork) {
            if (random <= 0.25) newToken["type"] = "B";
            else if (random <= 0.5) newToken["type"] = "W";
            else if (random <= 0.75) newToken["type"] = "F";
            else if (random <= 1) newToken["type"] = "S";
          } else {
            if (random <= 0.2) newToken["type"] = "B";
            else if (random <= 0.4) newToken["type"] = "W";
            else if (random <= 0.6) newToken["type"] = "3";
            else if (random <= 0.8) newToken["type"] = "F";
            else if (random <= 1) newToken["type"] = "S";
          }
        }
      }

      for (i = 0; i < n_brick_rows; i++) {
        for (j = 0; j < n_brick_cols; j++) {
          var brick_x_l = brick_padding + j * (brick_width + brick_padding);
          var brick_x_r =
            brick_width + brick_padding + j * (brick_width + brick_padding);
          var brick_y_b =
            brick_padding + brick_height + i * (brick_height + brick_padding);
          var brick_y_t = brick_padding + i * (brick_height + brick_padding);
          var brick_edge = brick_height * 0.4;
          var tokenY = brick_y_b;
          var tokenX =
            0.5 * brick_width +
            brick_padding +
            j * (brick_width + brick_padding);

          if (bricks[i][j] == 1) {
            for (ball in balls) {
              var y = balls[ball].y;
              var x = balls[ball].x;
              var dx = balls[ball].dx;
              var dy = balls[ball].dy;

              //directions
              var ballDirection;

              if (dx < 0 && dy < 0) ballDirection = "up left";
              if (dx > 0 && dy < 0) ballDirection = "up right";
              if (dx < 0 && dy > 0) ballDirection = "down left";
              if (dx > 0 && dy > 0) ballDirection = "down right";

              if (
                ballDirection == "up left" &&
                y + dy - radius <= brick_y_b &&
                y + dy + radius >= brick_y_t &&
                (x + dx - radius >= brick_x_l && x + dx - radius <= brick_x_r)
              ) {
                if (y - radius < brick_y_b) {
                  //dy = -(dy);
                  balls[ball].dx = -dx;
                } else {
                  balls[ball].dy = -dy;
                }
                brickHit(i, j, tokenY, tokenX);
              } else if (
                ballDirection == "down left" &&
                y + dy + radius >= brick_y_t &&
                y + dy - radius <= brick_y_b &&
                (x + dx - radius >= brick_x_l && x + dx - radius <= brick_x_r)
              ) {
                if (y + radius > brick_y_t) {
                  //dy = -(dy);
                  balls[ball].dx = -dx;
                } else {
                  balls[ball].dy = -dy;
                }
                brickHit(i, j, tokenY, tokenX);
              } else if (
                ballDirection == "up right" &&
                y + dy - radius <= brick_y_b &&
                y + dy + radius >= brick_y_t &&
                (x + dx + radius >= brick_x_l && x + dx + radius <= brick_x_r)
              ) {
                if (y - radius < brick_y_b) {
                  //dy = -(dy);
                  balls[ball].dx = -dx;
                } else {
                  balls[ball].dy = -dy;
                }
                brickHit(i, j, tokenY, tokenX);
              } else if (
                ballDirection == "down right" &&
                y + dy + radius >= brick_y_t &&
                y + dy - radius <= brick_y_b &&
                (x + dx + radius >= brick_x_l && x + dx + radius < brick_x_r)
              ) {
                if (y + radius > brick_y_t) {
                  //dy = -(dy);
                  balls[ball].dx = -dx;
                } else {
                  balls[ball].dy = -dy;
                }
                brickHit(i, j, tokenY, tokenX);
              }
            }
          }
        }

        //walls

        for (ball in balls) {
          var y = balls[ball].y;
          var x = balls[ball].x;
          var dx = balls[ball].dx;
          var dy = balls[ball].dy;

          if (x + dx + radius > WIDTH || x + dx - radius < 0) {
            balls[ball].dx = -dx;
          }

          if (y + dy - radius < 0) {
            balls[ball].dy = -dy;
          }

          //paddle
          if (y + dy > HEIGHT - radius - paddleh && lostCount == 0) {
            if (
              x + dx > paddlex - radius * 2 &&
              x + dx < paddlex + paddlew + radius * 2
            ) {
              //below surface or on edge
              if (
                HEIGHT - y - dy < paddleh ||
                x + dx < paddlex + paddlew * 0.1 + radius * 2 ||
                x + dx > paddlex + paddlew * 0.9 - radius * 2
              ) {
                //considering current movement
                if ((rightDown && dx > 0) || (leftDown && dx < 0)) {
                  balls[ball].dy = -dy;
                  paddleColor = "#ffc933";
                  paddleTouch = true;
                } else {
                  balls[ball].dy = -dy;
                  balls[ball].dx = -dx;
                  paddleColor = "#ffc933";
                  paddleTouch = true;
                }
              } else {
                balls[ball].dy = -dy;
                paddleColor = "#ffc933";
                paddleTouch = true;
              }
            }
          }
          //lost
          if (y > HEIGHT + radius) {
            delete balls[ball];
            //var emptyCheck = isEmpty();
            if (isEmpty()) {
              clearInterval(frames);
              $("#announce").append(" game over");
              endGameData = {
                score: score,
                game: "Brick-Breaker"
              };
              apiClientCreator(`users/score`)
                .post("", { score: endGameData.score, game: endGameData.game })
                .then(res => {
                  return res;
                });
              $("#announce").show();
              gameOver = true;
            }
          }
        }
      }
    }

    //mouse and keyboard

    function keyDown(key) {
      if (key.keyCode == 39) rightDown = true;
      else if (key.keyCode == 37) leftDown = true;
      else if (key.keyCode == 32) {
        initPause();
      }
    }

    function initPause() {
      if (!gameOver && !prepause) {
        if (!pause) {
          clearInterval(frames);
          pause = true;
          $("#announce").html("pause");
          $("#announce").show();
          pauseAnimate();
        } else if (pause) {
          frames = setInterval(draw, 20);
          pause = false;
          $("#announce").hide();
        }
      }
    }

    function keyUp(key) {
      if (key.keyCode == 39) rightDown = false;
      else if (key.keyCode == 37) leftDown = false;
    }

    function init_mouse() {
      if (document.getElementById("canvas") != undefined) {
        canvasStart = $("#canvas").offset().left;
      }

      canvasMinX = canvasStart - paddlew * 0.2;
      canvasMaxX = canvasStart + WIDTH - paddlew * 0.2;
    }

    function onMouseMove(evt) {
      init_mouse();
      if (evt.pageX > canvasMinX && evt.pageX < canvasMaxX) {
        paddlex = evt.pageX - canvasStart;
      }
    }

    //animations

    function startAnimate() {
      $("#canvas").css({ height: 550, width: 850, opacity: 0 });
      $(".sidebar").css({ right: 150, opacity: 0 });
      $("#canvas").animate(
        { width: "990px", height: "600px", opacity: 1 },
        250
      );
      $(".sidebar")
        .delay(250)
        .animate({ right: "0px", opacity: 1 }, 550);
    }

    function pauseAnimate() {
      if (pause) {
        $("#announce").animate({ top: 150 }, 350, function() {
          $("#announce").animate({ top: 155 }, 350, function() {
            pauseAnimate();
          });
        });
      }
    }

    function isEmpty() {
      for (ball in balls) {
        return false;
      }
      return true;
    }
    // Only add this code if we do not already have a canvas implementation
    if (!document.createElement("canvas").getContext) {
      (function() {
        // alias some functions to make (compiled) code shorter
        var m = Math;
        var mr = m.round;
        var ms = m.sin;
        var mc = m.cos;
        var abs = m.abs;
        var sqrt = m.sqrt;

        // this is used for sub pixel precision
        var Z = 10;
        var Z2 = Z / 2;

        /**
         * This funtion is assigned to the <canvas> elements as element.getContext().
         * @this {HTMLElement}
         * @return {CanvasRenderingContext2D_}
         */
        function getContext() {
          return (
            this.context_ ||
            (this.context_ = new CanvasRenderingContext2D_(this))
          );
        }

        var slice = Array.prototype.slice;

        /**
         * Binds a function to an object. The returned function will always use the
         * passed in {@code obj} as {@code this}.
         *
         * Example:
         *
         *   g = bind(f, obj, a, b)
         *   g(c, d) // will do f.call(obj, a, b, c, d)
         *
         * @param {Function} f The function to bind the object to
         * @param {Object} obj The object that should act as this when the function
         *     is called
         * @param {*} var_args Rest arguments that will be used as the initial
         *     arguments when the function is called
         * @return {Function} A new function that has bound this
         */
        function bind(f, obj, var_args) {
          var a = slice.call(arguments, 2);
          return function() {
            return f.apply(obj, a.concat(slice.call(arguments)));
          };
        }

        var G_vmlCanvasManager_ = {
          init: function(opt_doc) {
            if (/MSIE/.test(navigator.userAgent) && !window.opera) {
              var doc = opt_doc || document;
              // Create a dummy element so that IE will allow canvas elements to be
              // recognized.
              doc.createElement("canvas");
              doc.attachEvent(
                "onreadystatechange",
                bind(this.init_, this, doc)
              );
            }
          },

          init_: function(doc) {
            // create xmlns
            if (!doc.namespaces["g_vml_"]) {
              doc.namespaces.add(
                "g_vml_",
                "urn:schemas-microsoft-com:vml",
                "#default#VML"
              );
            }
            if (!doc.namespaces["g_o_"]) {
              doc.namespaces.add(
                "g_o_",
                "urn:schemas-microsoft-com:office:office",
                "#default#VML"
              );
            }

            // Setup default CSS.  Only add one style sheet per document
            if (!doc.styleSheets["ex_canvas_"]) {
              var ss = doc.createStyleSheet();
              ss.owningElement.id = "ex_canvas_";
              ss.cssText =
                "canvas{display:inline-block;overflow:hidden;" +
                // default size is 300x150 in Gecko and Opera
                "text-align:left;width:300px;height:150px}" +
                "g_vml_\\:*{behavior:url(#default#VML)}" +
                "g_o_\\:*{behavior:url(#default#VML)}";
            }

            // find all canvas elements
            var els = doc.getElementsByTagName("canvas");
            for (var i = 0; i < els.length; i++) {
              this.initElement(els[i]);
            }
          },

          /**
           * Public initializes a canvas element so that it can be used as canvas
           * element from now on. This is called automatically before the page is
           * loaded but if you are creating elements using createElement you need to
           * make sure this is called on the element.
           * @param {HTMLElement} el The canvas element to initialize.
           * @return {HTMLElement} the element that was created.
           */
          initElement: function(el) {
            if (!el.getContext) {
              el.getContext = getContext;

              // Remove fallback content. There is no way to hide text nodes so we
              // just remove all childNodes. We could hide all elements and remove
              // text nodes but who really cares about the fallback content.
              el.innerHTML = "";

              // do not use inline function because that will leak memory
              el.attachEvent("onpropertychange", onPropertyChange);
              el.attachEvent("onresize", onResize);

              var attrs = el.attributes;
              if (attrs.width && attrs.width.specified) {
                // ODO: use runtimeStyle and coordsize
                // el.getContext().setWidth_(attrs.width.nodeValue);
                el.style.width = attrs.width.nodeValue + "px";
              } else {
                el.width = el.clientWidth;
              }
              if (attrs.height && attrs.height.specified) {
                // ODO: use runtimeStyle and coordsize
                // el.getContext().setHeight_(attrs.height.nodeValue);
                el.style.height = attrs.height.nodeValue + "px";
              } else {
                el.height = el.clientHeight;
              }
              //el.getContext().setCoordsize_()
            }
            return el;
          }
        };

        function onPropertyChange(e) {
          var el = e.srcElement;

          switch (e.propertyName) {
            case "width":
              el.style.width = el.attributes.width.nodeValue + "px";
              el.getContext().clearRect();
              break;
            case "height":
              el.style.height = el.attributes.height.nodeValue + "px";
              el.getContext().clearRect();
              break;
          }
        }

        function onResize(e) {
          var el = e.srcElement;
          if (el.firstChild) {
            el.firstChild.style.width = el.clientWidth + "px";
            el.firstChild.style.height = el.clientHeight + "px";
          }
        }

        G_vmlCanvasManager_.init();

        // precompute "00" to "FF"
        var dec2hex = [];
        for (var i = 0; i < 16; i++) {
          for (var j = 0; j < 16; j++) {
            dec2hex[i * 16 + j] = i.toString(16) + j.toString(16);
          }
        }

        function createMatrixIdentity() {
          return [[1, 0, 0], [0, 1, 0], [0, 0, 1]];
        }

        function matrixMultiply(m1, m2) {
          var result = createMatrixIdentity();

          for (var x = 0; x < 3; x++) {
            for (var y = 0; y < 3; y++) {
              var sum = 0;

              for (var z = 0; z < 3; z++) {
                sum += m1[x][z] * m2[z][y];
              }

              result[x][y] = sum;
            }
          }
          return result;
        }

        function copyState(o1, o2) {
          o2.fillStyle = o1.fillStyle;
          o2.lineCap = o1.lineCap;
          o2.lineJoin = o1.lineJoin;
          o2.lineWidth = o1.lineWidth;
          o2.miterLimit = o1.miterLimit;
          o2.shadowBlur = o1.shadowBlur;
          o2.shadowColor = o1.shadowColor;
          o2.shadowOffsetX = o1.shadowOffsetX;
          o2.shadowOffsetY = o1.shadowOffsetY;
          o2.strokeStyle = o1.strokeStyle;
          o2.globalAlpha = o1.globalAlpha;
          o2.arcScaleX_ = o1.arcScaleX_;
          o2.arcScaleY_ = o1.arcScaleY_;
          o2.lineScale_ = o1.lineScale_;
        }

        function processStyle(styleString) {
          var str,
            alpha = 1;

          styleString = String(styleString);
          if (styleString.substring(0, 3) == "rgb") {
            var start = styleString.indexOf("(", 3);
            var end = styleString.indexOf(")", start + 1);
            var guts = styleString.substring(start + 1, end).split(",");

            str = "#";
            for (var i = 0; i < 3; i++) {
              str += dec2hex[Number(guts[i])];
            }

            if (guts.length == 4 && styleString.substr(3, 1) == "a") {
              alpha = guts[3];
            }
          } else {
            str = styleString;
          }

          return { color: str, alpha: alpha };
        }

        function processLineCap(lineCap) {
          switch (lineCap) {
            case "butt":
              return "flat";
            case "round":
              return "round";
            case "square":
            default:
              return "square";
          }
        }

        /**
         * This class implements CanvasRenderingContext2D interface as described by
         * the WHATWG.
         * @param {HTMLElement} surfaceElement The element that the 2D context should
         * be associated with
         */
        function CanvasRenderingContext2D_(surfaceElement) {
          this.m_ = createMatrixIdentity();

          this.mStack_ = [];
          this.aStack_ = [];
          this.currentPath_ = [];

          // Canvas context properties
          this.strokeStyle = "#000";
          this.fillStyle = "#000";

          this.lineWidth = 1;
          this.lineJoin = "miter";
          this.lineCap = "butt";
          this.miterLimit = Z * 1;
          this.globalAlpha = 1;
          this.canvas = surfaceElement;

          var el = surfaceElement.ownerDocument.createElement("div");
          el.style.width = surfaceElement.clientWidth + "px";
          el.style.height = surfaceElement.clientHeight + "px";
          el.style.overflow = "hidden";
          el.style.position = "absolute";
          surfaceElement.appendChild(el);

          this.element_ = el;
          this.arcScaleX_ = 1;
          this.arcScaleY_ = 1;
          this.lineScale_ = 1;
        }

        var contextPrototype = CanvasRenderingContext2D_.prototype;
        contextPrototype.clearRect = function() {
          this.element_.innerHTML = "";
        };

        contextPrototype.beginPath = function() {
          // ODO: Branch current matrix so that save/restore has no effect
          //       as per safari docs.
          this.currentPath_ = [];
        };

        contextPrototype.moveTo = function(aX, aY) {
          var p = this.getCoords_(aX, aY);
          this.currentPath_.push({ type: "moveTo", x: p.x, y: p.y });
          this.currentX_ = p.x;
          this.currentY_ = p.y;
        };

        contextPrototype.lineTo = function(aX, aY) {
          var p = this.getCoords_(aX, aY);
          this.currentPath_.push({ type: "lineTo", x: p.x, y: p.y });

          this.currentX_ = p.x;
          this.currentY_ = p.y;
        };

        contextPrototype.bezierCurveTo = function(
          aCP1x,
          aCP1y,
          aCP2x,
          aCP2y,
          aX,
          aY
        ) {
          var p = this.getCoords_(aX, aY);
          var cp1 = this.getCoords_(aCP1x, aCP1y);
          var cp2 = this.getCoords_(aCP2x, aCP2y);
          bezierCurveTo(this, cp1, cp2, p);
        };

        // Helper function that takes the already fixed cordinates.
        function bezierCurveTo(self, cp1, cp2, p) {
          self.currentPath_.push({
            type: "bezierCurveTo",
            cp1x: cp1.x,
            cp1y: cp1.y,
            cp2x: cp2.x,
            cp2y: cp2.y,
            x: p.x,
            y: p.y
          });
          self.currentX_ = p.x;
          self.currentY_ = p.y;
        }

        contextPrototype.quadraticCurveTo = function(aCPx, aCPy, aX, aY) {
          // the following is lifted almost directly from
          // http://developer.mozilla.org/en/docs/Canvas_tutorial:Drawing_shapes

          var cp = this.getCoords_(aCPx, aCPy);
          var p = this.getCoords_(aX, aY);

          var cp1 = {
            x: this.currentX_ + (2.0 / 3.0) * (cp.x - this.currentX_),
            y: this.currentY_ + (2.0 / 3.0) * (cp.y - this.currentY_)
          };
          var cp2 = {
            x: cp1.x + (p.x - this.currentX_) / 3.0,
            y: cp1.y + (p.y - this.currentY_) / 3.0
          };

          bezierCurveTo(this, cp1, cp2, p);
        };

        contextPrototype.arc = function(
          aX,
          aY,
          aRadius,
          aStartAngle,
          aEndAngle,
          aClockwise
        ) {
          aRadius *= Z;
          var arcType = aClockwise ? "at" : "wa";

          var xStart = aX + mc(aStartAngle) * aRadius - Z2;
          var yStart = aY + ms(aStartAngle) * aRadius - Z2;

          var xEnd = aX + mc(aEndAngle) * aRadius - Z2;
          var yEnd = aY + ms(aEndAngle) * aRadius - Z2;

          // IE won't render arches drawn counter clockwise if xStart == xEnd.
          if (xStart == xEnd && !aClockwise) {
            xStart += 0.125; // Offset xStart by 1/80 of a pixel. Use something
            // that can be represented in binary
          }

          var p = this.getCoords_(aX, aY);
          var pStart = this.getCoords_(xStart, yStart);
          var pEnd = this.getCoords_(xEnd, yEnd);

          this.currentPath_.push({
            type: arcType,
            x: p.x,
            y: p.y,
            radius: aRadius,
            xStart: pStart.x,
            yStart: pStart.y,
            xEnd: pEnd.x,
            yEnd: pEnd.y
          });
        };

        contextPrototype.rect = function(aX, aY, aWidth, aHeight) {
          this.moveTo(aX, aY);
          this.lineTo(aX + aWidth, aY);
          this.lineTo(aX + aWidth, aY + aHeight);
          this.lineTo(aX, aY + aHeight);
          this.closePath();
        };

        contextPrototype.strokeRect = function(aX, aY, aWidth, aHeight) {
          var oldPath = this.currentPath_;
          this.beginPath();

          this.moveTo(aX, aY);
          this.lineTo(aX + aWidth, aY);
          this.lineTo(aX + aWidth, aY + aHeight);
          this.lineTo(aX, aY + aHeight);
          this.closePath();
          this.stroke();

          this.currentPath_ = oldPath;
        };

        contextPrototype.fillRect = function(aX, aY, aWidth, aHeight) {
          var oldPath = this.currentPath_;
          this.beginPath();

          this.moveTo(aX, aY);
          this.lineTo(aX + aWidth, aY);
          this.lineTo(aX + aWidth, aY + aHeight);
          this.lineTo(aX, aY + aHeight);
          this.closePath();
          this.fill();

          this.currentPath_ = oldPath;
        };

        contextPrototype.createLinearGradient = function(aX0, aY0, aX1, aY1) {
          var gradient = new CanvasGradient_("gradient");
          gradient.x0_ = aX0;
          gradient.y0_ = aY0;
          gradient.x1_ = aX1;
          gradient.y1_ = aY1;
          return gradient;
        };

        contextPrototype.createRadialGradient = function(
          aX0,
          aY0,
          aR0,
          aX1,
          aY1,
          aR1
        ) {
          var gradient = new CanvasGradient_("gradientradial");
          gradient.x0_ = aX0;
          gradient.y0_ = aY0;
          gradient.r0_ = aR0;
          gradient.x1_ = aX1;
          gradient.y1_ = aY1;
          gradient.r1_ = aR1;
          return gradient;
        };

        contextPrototype.drawImage = function(image, var_args) {
          var dx, dy, dw, dh, sx, sy, sw, sh;

          // to find the original width we overide the width and height
          var oldRuntimeWidth = image.runtimeStyle.width;
          var oldRuntimeHeight = image.runtimeStyle.height;
          image.runtimeStyle.width = "auto";
          image.runtimeStyle.height = "auto";

          // get the original size
          var w = image.width;
          var h = image.height;

          // and remove overides
          image.runtimeStyle.width = oldRuntimeWidth;
          image.runtimeStyle.height = oldRuntimeHeight;

          if (arguments.length == 3) {
            dx = arguments[1];
            dy = arguments[2];
            sx = sy = 0;
            sw = dw = w;
            sh = dh = h;
          } else if (arguments.length == 5) {
            dx = arguments[1];
            dy = arguments[2];
            dw = arguments[3];
            dh = arguments[4];
            sx = sy = 0;
            sw = w;
            sh = h;
          } else if (arguments.length == 9) {
            sx = arguments[1];
            sy = arguments[2];
            sw = arguments[3];
            sh = arguments[4];
            dx = arguments[5];
            dy = arguments[6];
            dw = arguments[7];
            dh = arguments[8];
          } else {
            throw Error("Invalid number of arguments");
          }

          var d = this.getCoords_(dx, dy);

          var w2 = sw / 2;
          var h2 = sh / 2;

          var vmlStr = [];

          var W = 10;
          var H = 10;

          // For some reason that I've now forgotten, using divs didn't work
          vmlStr.push(
            " <g_vml_:group",
            ' coordsize="',
            Z * W,
            ",",
            Z * H,
            '"',
            ' coordorigin="0,0"',
            ' style="width:',
            W,
            "px;height:",
            H,
            "px;position:absolute;"
          );

          // If filters are necessary (rotation exists), create them
          // filters are bog-slow, so only create them if abbsolutely necessary
          // The following check doesn't account for skews (which don't exist
          // in the canvas spec (yet) anyway.

          if (this.m_[0][0] != 1 || this.m_[0][1]) {
            var filter = [];

            // Note the 12/21 reversal
            filter.push(
              "M11=",
              this.m_[0][0],
              ",",
              "M12=",
              this.m_[1][0],
              ",",
              "M21=",
              this.m_[0][1],
              ",",
              "M22=",
              this.m_[1][1],
              ",",
              "Dx=",
              mr(d.x / Z),
              ",",
              "Dy=",
              mr(d.y / Z),
              ""
            );

            // Bounding box calculation (need to minimize displayed area so that
            // filters don't waste time on unused pixels.
            var max = d;
            var c2 = this.getCoords_(dx + dw, dy);
            var c3 = this.getCoords_(dx, dy + dh);
            var c4 = this.getCoords_(dx + dw, dy + dh);

            max.x = m.max(max.x, c2.x, c3.x, c4.x);
            max.y = m.max(max.y, c2.y, c3.y, c4.y);

            vmlStr.push(
              "padding:0 ",
              mr(max.x / Z),
              "px ",
              mr(max.y / Z),
              "px 0;filter:progid:DXImageTransform.Microsoft.Matrix(",
              filter.join(""),
              ", sizingmethod='clip');"
            );
          } else {
            vmlStr.push("top:", mr(d.y / Z), "px;left:", mr(d.x / Z), "px;");
          }

          vmlStr.push(
            ' ">',
            '<g_vml_:image src="',
            image.src,
            '"',
            ' style="width:',
            Z * dw,
            "px;",
            " height:",
            Z * dh,
            'px;"',
            ' cropleft="',
            sx / w,
            '"',
            ' croptop="',
            sy / h,
            '"',
            ' cropright="',
            (w - sx - sw) / w,
            '"',
            ' cropbottom="',
            (h - sy - sh) / h,
            '"',
            " />",
            "</g_vml_:group>"
          );

          this.element_.insertAdjacentHTML("BeforeEnd", vmlStr.join(""));
        };

        contextPrototype.stroke = function(aFill) {
          var lineStr = [];
          var lineOpen = false;
          var a = processStyle(aFill ? this.fillStyle : this.strokeStyle);
          var color = a.color;
          var opacity = a.alpha * this.globalAlpha;

          var W = 10;
          var H = 10;

          lineStr.push(
            "<g_vml_:shape",
            ' filled="',
            !!aFill,
            '"',
            ' style="position:absolute;width:',
            W,
            "px;height:",
            H,
            'px;"',
            ' coordorigin="0 0" coordsize="',
            Z * W,
            " ",
            Z * H,
            '"',
            ' stroked="',
            !aFill,
            '"',
            ' path="'
          );

          var newSeq = false;
          var min = { x: null, y: null };
          var max = { x: null, y: null };

          for (var i = 0; i < this.currentPath_.length; i++) {
            var p = this.currentPath_[i];
            var c;

            switch (p.type) {
              case "moveTo":
                c = p;
                lineStr.push(" m ", mr(p.x), ",", mr(p.y));
                break;
              case "lineTo":
                lineStr.push(" l ", mr(p.x), ",", mr(p.y));
                break;
              case "close":
                lineStr.push(" x ");
                p = null;
                break;
              case "bezierCurveTo":
                lineStr.push(
                  " c ",
                  mr(p.cp1x),
                  ",",
                  mr(p.cp1y),
                  ",",
                  mr(p.cp2x),
                  ",",
                  mr(p.cp2y),
                  ",",
                  mr(p.x),
                  ",",
                  mr(p.y)
                );
                break;
              case "at":
              case "wa":
                lineStr.push(
                  " ",
                  p.type,
                  " ",
                  mr(p.x - this.arcScaleX_ * p.radius),
                  ",",
                  mr(p.y - this.arcScaleY_ * p.radius),
                  " ",
                  mr(p.x + this.arcScaleX_ * p.radius),
                  ",",
                  mr(p.y + this.arcScaleY_ * p.radius),
                  " ",
                  mr(p.xStart),
                  ",",
                  mr(p.yStart),
                  " ",
                  mr(p.xEnd),
                  ",",
                  mr(p.yEnd)
                );
                break;
            }

            // ODO: Following is broken for curves due to
            //       move to proper paths.

            // Figure out dimensions so we can do gradient fills
            // properly
            if (p) {
              if (min.x == null || p.x < min.x) {
                min.x = p.x;
              }
              if (max.x == null || p.x > max.x) {
                max.x = p.x;
              }
              if (min.y == null || p.y < min.y) {
                min.y = p.y;
              }
              if (max.y == null || p.y > max.y) {
                max.y = p.y;
              }
            }
          }
          lineStr.push(' ">');

          if (!aFill) {
            var lineWidth = this.lineScale_ * this.lineWidth;

            // VML cannot correctly render a line if the width is less than 1px.
            // In that case, we dilute the color to make the line look thinner.
            if (lineWidth < 1) {
              opacity *= lineWidth;
            }

            lineStr.push(
              "<g_vml_:stroke",
              ' opacity="',
              opacity,
              '"',
              ' joinstyle="',
              this.lineJoin,
              '"',
              ' miterlimit="',
              this.miterLimit,
              '"',
              ' endcap="',
              processLineCap(this.lineCap),
              '"',
              ' weight="',
              lineWidth,
              'px"',
              ' color="',
              color,
              '" />'
            );
          } else if (typeof this.fillStyle == "object") {
            var fillStyle = this.fillStyle;
            var angle = 0;
            var focus = { x: 0, y: 0 };

            // additional offset
            var shift = 0;
            // scale factor for offset
            var expansion = 1;

            if (fillStyle.type_ == "gradient") {
              var x0 = fillStyle.x0_ / this.arcScaleX_;
              var y0 = fillStyle.y0_ / this.arcScaleY_;
              var x1 = fillStyle.x1_ / this.arcScaleX_;
              var y1 = fillStyle.y1_ / this.arcScaleY_;
              var p0 = this.getCoords_(x0, y0);
              var p1 = this.getCoords_(x1, y1);
              var dx = p1.x - p0.x;
              var dy = p1.y - p0.y;
              angle = (Math.atan2(dx, dy) * 180) / Math.PI;

              // The angle should be a non-negative number.
              if (angle < 0) {
                angle += 360;
              }

              // Very small angles produce an unexpected result because they are
              // converted to a scientific notation string.
              if (angle < 1e-6) {
                angle = 0;
              }
            } else {
              var p0 = this.getCoords_(fillStyle.x0_, fillStyle.y0_);
              var width = max.x - min.x;
              var height = max.y - min.y;
              focus = {
                x: (p0.x - min.x) / width,
                y: (p0.y - min.y) / height
              };

              width /= this.arcScaleX_ * Z;
              height /= this.arcScaleY_ * Z;
              var dimension = m.max(width, height);
              shift = (2 * fillStyle.r0_) / dimension;
              expansion = (2 * fillStyle.r1_) / dimension - shift;
            }

            // We need to sort the color stops in ascending order by offset,
            // otherwise IE won't interpret it correctly.
            var stops = fillStyle.colors_;
            stops.sort(function(cs1, cs2) {
              return cs1.offset - cs2.offset;
            });

            var length = stops.length;
            var color1 = stops[0].color;
            var color2 = stops[length - 1].color;
            var opacity1 = stops[0].alpha * this.globalAlpha;
            var opacity2 = stops[length - 1].alpha * this.globalAlpha;

            var colors = [];
            for (var i = 0; i < length; i++) {
              var stop = stops[i];
              colors.push(stop.offset * expansion + shift + " " + stop.color);
            }

            // When colors attribute is used, the meanings of opacity and o:opacity2
            // are reversed.
            lineStr.push(
              '<g_vml_:fill type="',
              fillStyle.type_,
              '"',
              ' method="none" focus="100%"',
              ' color="',
              color1,
              '"',
              ' color2="',
              color2,
              '"',
              ' colors="',
              colors.join(","),
              '"',
              ' opacity="',
              opacity2,
              '"',
              ' g_o_:opacity2="',
              opacity1,
              '"',
              ' angle="',
              angle,
              '"',
              ' focusposition="',
              focus.x,
              ",",
              focus.y,
              '" />'
            );
          } else {
            lineStr.push(
              '<g_vml_:fill color="',
              color,
              '" opacity="',
              opacity,
              '" />'
            );
          }

          lineStr.push("</g_vml_:shape>");

          this.element_.insertAdjacentHTML("beforeEnd", lineStr.join(""));
        };

        contextPrototype.fill = function() {
          this.stroke(true);
        };

        contextPrototype.closePath = function() {
          this.currentPath_.push({ type: "close" });
        };

        /**
         * @private
         */
        contextPrototype.getCoords_ = function(aX, aY) {
          var m = this.m_;
          return {
            x: Z * (aX * m[0][0] + aY * m[1][0] + m[2][0]) - Z2,
            y: Z * (aX * m[0][1] + aY * m[1][1] + m[2][1]) - Z2
          };
        };

        contextPrototype.save = function() {
          var o = {};
          copyState(this, o);
          this.aStack_.push(o);
          this.mStack_.push(this.m_);
          this.m_ = matrixMultiply(createMatrixIdentity(), this.m_);
        };

        contextPrototype.restore = function() {
          copyState(this.aStack_.pop(), this);
          this.m_ = this.mStack_.pop();
        };

        function matrixIsFinite(m) {
          for (var j = 0; j < 3; j++) {
            for (var k = 0; k < 2; k++) {
              if (!isFinite(m[j][k]) || isNaN(m[j][k])) {
                return false;
              }
            }
          }
          return true;
        }

        function setM(ctx, m, updateLineScale) {
          if (!matrixIsFinite(m)) {
            return;
          }
          ctx.m_ = m;

          if (updateLineScale) {
            // Get the line scale.
            // Determinant of this.m_ means how much the area is enlarged by the
            // transformation. So its square root can be used as a scale factor
            // for width.
            var det = m[0][0] * m[1][1] - m[0][1] * m[1][0];
            ctx.lineScale_ = sqrt(abs(det));
          }
        }

        contextPrototype.translate = function(aX, aY) {
          var m1 = [[1, 0, 0], [0, 1, 0], [aX, aY, 1]];

          setM(this, matrixMultiply(m1, this.m_), false);
        };

        contextPrototype.rotate = function(aRot) {
          var c = mc(aRot);
          var s = ms(aRot);

          var m1 = [[c, s, 0], [-s, c, 0], [0, 0, 1]];

          setM(this, matrixMultiply(m1, this.m_), false);
        };

        contextPrototype.scale = function(aX, aY) {
          this.arcScaleX_ *= aX;
          this.arcScaleY_ *= aY;
          var m1 = [[aX, 0, 0], [0, aY, 0], [0, 0, 1]];

          setM(this, matrixMultiply(m1, this.m_), true);
        };

        contextPrototype.transform = function(m11, m12, m21, m22, dx, dy) {
          var m1 = [[m11, m12, 0], [m21, m22, 0], [dx, dy, 1]];

          setM(this, matrixMultiply(m1, this.m_), true);
        };

        contextPrototype.setTransform = function(m11, m12, m21, m22, dx, dy) {
          var m = [[m11, m12, 0], [m21, m22, 0], [dx, dy, 1]];

          setM(this, m, true);
        };

        /******** STUBS ********/
        contextPrototype.clip = function() {
          // ODO: Implement
        };

        contextPrototype.arcTo = function() {
          // ODO: Implement
        };

        contextPrototype.createPattern = function() {
          return new CanvasPattern_();
        };

        // Gradient / Pattern Stubs
        function CanvasGradient_(aType) {
          this.type_ = aType;
          this.x0_ = 0;
          this.y0_ = 0;
          this.r0_ = 0;
          this.x1_ = 0;
          this.y1_ = 0;
          this.r1_ = 0;
          this.colors_ = [];
        }

        CanvasGradient_.prototype.addColorStop = function(aOffset, aColor) {
          aColor = processStyle(aColor);
          this.colors_.push({
            offset: aOffset,
            color: aColor.color,
            alpha: aColor.alpha
          });
        };

        function CanvasPattern_() {}

        // set up externs
        G_vmlCanvasManager = G_vmlCanvasManager_;
        CanvasRenderingContext2D = CanvasRenderingContext2D_;
        CanvasGradient = CanvasGradient_;
        CanvasPattern = CanvasPattern_;
      })();
    } // if
  }
};
